import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { useFormattingContext } from '../../FormattingProvider/FormattingContext'
import { useFirmReportSummary } from '../../../../api/coreData'
import OpalPresentationTable from '../tables/presentation'

const columnConfig = [
  { id: 'filter', accessorKey: 'filter', align: 'left', header: 'Filter' },
  { id: 'metric', accessorKey: 'metric', align: 'left', header: 'Metric' },
  { id: 'value', accessorKey: 'value', align: 'right', header: 'Value' }
]

function DenaliReportSummary ({ reportId }) {
  const { formatter } = useFormattingContext()

  const dataQuery = useMemo(() => {
    return {
    }
  }, [])
  const { data, isLoading } = useFirmReportSummary(reportId, { enabled: !!dataQuery, ...dataQuery })
  const mappedData = useMemo(() => {
    return (data?.summary || []).flatMap(item => {
      return Object.entries(item.metrics).map(([key, value]) => ({
        filter: item.name,
        metric: key,
        value: formatter(value, 'marketValue')
      }))
    })
  }, [data, formatter])

  if (isLoading) return null

  return (
    <FadeIn>
      <OpalPresentationTable
        columns={columnConfig}
        data={mappedData}
        includeHeader
      />
    </FadeIn>
  )
}

DenaliReportSummary.propTypes = {
  reportId: PropTypes.string
}

export default DenaliReportSummary
